import { NoData } from '../../components/Illustrations/NoData';
import { Tabs, TabsStrategy, TabsVariant } from '../../components/Tabs';

import { WorkflowGraph } from './WorkflowGraph';
import type {
  WorkflowSelection,
  WorkflowStateLookup,
} from './utils/build-workflow-graph.util';
import type { WorkflowEntry } from './types/workflow-entry.type';

interface EntityWorkflowsProps {
  readonly getState: WorkflowStateLookup;
  readonly label: string;
  readonly onSelect: (selection: Readonly<WorkflowSelection>) => void;
  readonly workflows: readonly WorkflowEntry[];
}

export const EntityWorkflows = ({
  getState,
  label,
  onSelect,
  workflows,
}: Readonly<EntityWorkflowsProps>) => {
  const [firstWorkflow] = workflows;

  if (!firstWorkflow) {
    return <NoData title={`Aucun workflow pour ${label}`} />;
  }

  if (workflows.length === 1) {
    return (
      <WorkflowGraph
        getState={getState}
        onSelect={onSelect}
        workflow={firstWorkflow}
      />
    );
  }

  return (
    <Tabs
      id={`workflows-${label}`}
      strategy={TabsStrategy.Stateful}
      tabs={workflows.map((workflow) => ({
        key: workflow._id,
        value: workflow._id,
        label: workflow.label,
        panel: (
          <WorkflowGraph
            getState={getState}
            onSelect={onSelect}
            workflow={workflow}
          />
        ),
      }))}
      title={`Workflows ${label}`}
      variant={TabsVariant.Vertical}
    />
  );
};
